import { ChevronDownIcon } from '@/shared/icons'

import s from './Select.module.css'

interface SelectProps<T extends string> {
  value: T
  onChange: (value: T) => void
  options: ReadonlyArray<{ value: T; label: string }>
  'aria-label': string
  id?: string
}

/** Нативный select с собственной стрелкой: системная в разных браузерах уезжает от центра. */
export function Select<T extends string>({
  value,
  onChange,
  options,
  id,
  ...rest
}: SelectProps<T>) {
  return (
    <span className={s.wrap}>
      <select
        id={id}
        className={s.select}
        value={value}
        onChange={(event) => onChange(event.target.value as T)}
        aria-label={rest['aria-label']}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className={s.chevron}>
        <ChevronDownIcon size={14} />
      </span>
    </span>
  )
}
